// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-loading-image::before, .k-loading-image::after {
  top: 60px !important;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/OI/WidgetGridLoader.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ","sourcesContent":[".k-loading-image::before, .k-loading-image::after{\n    top: 60px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
